"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var pp_react_1 = require("@paypalcorp/pp-react");
var pp_react_radio_1 = require("@paypalcorp/pp-react-radio");
var ajax_util_1 = require("../../../utils/ajax/ajax.util");
var addressErrors_1 = require("../../../utils/errorcodes/addressErrors");
var constants_1 = require("../../../constants");
var commonweb_utils_1 = require("commonweb-utils");
var interpolate_1 = require("../../../utils/interpolate/interpolate");
var addresses_1 = require("../../../actions/addresses");
var interpolate_component_1 = require("../../../components/interpolate-component");
var triggerOperationResult_1 = require("../../../utils/fpti/triggerOperationResult");
var addressDisplay_1 = require("./addressDisplay");
var commonUtils_1 = require("../../../common/utils/commonUtils");
var update_billing_message_view_1 = require("./update-billing-message.view");
var constants_2 = require("./constants");
var route_utils_1 = require("../../../route.utils");
var page = require("page");
var ROUTES = constants_1.default.ROUTES, VIEWS = constants_1.default.VIEWS, FPTI = constants_1.default.FPTI;
/**
 * Remove billing address component
 * @author asebastian
 */
var RemoveBillingAddress = /** @class */ (function (_super) {
    tslib_1.__extends(RemoveBillingAddress, _super);
    function RemoveBillingAddress(props) {
        var _this = _super.call(this, props) || this;
        _this.onClickRadio = function (event) {
            var selectedAddress = JSON.parse(event.target.value);
            var updatedForm = tslib_1.__assign({}, _this.state.form);
            updatedForm.newBillingAddress = selectedAddress;
            _this.setState({ form: updatedForm });
        };
        _this.onAddClick = function (event) {
            event.preventDefault();
            var url = constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.ADDRESSES.BILLING.ADD;
            url = url.replace(":id", commonweb_utils_1.objectUtils.safeGet(_this.props, "route.enter.params.id"));
            page(url);
        };
        _this.getGenericError = function () {
            var customerCareUrl = _this.props.links.help.linkUrl;
            var ccLinkComponent = (React.createElement(pp_react_1.Link, { key: _this.props.commonContent.customerCareLink, href: customerCareUrl }, _this.props.commonContent.customerCareLink));
            var convertedErrorContent = interpolate_component_1.InterpolateLinksWithComponent(_this.props.commonContent.error.errorGeneric, [ccLinkComponent]);
            return convertedErrorContent;
        };
        _this.submitHandler = function (event) {
            event.preventDefault();
            if (_this.state.form.newBillingAddress === null) {
                _this.setState({
                    errorMessage: _this.props.addressContent.removeBilling
                        .infoAlert,
                }, function () {
                    _this.setErrorMessageInView();
                });
                return;
            }
            _this.setState({ showSpinner: true });
            var formData = {};
            for (var formElementIdentifier in _this.state.form) {
                formData[formElementIdentifier] = _this.state.form[formElementIdentifier];
            }
            var postData = tslib_1.__assign({}, formData), removeAddressId = commonweb_utils_1.objectUtils.safeGet(_this.props, "route.enter.params.id") || "", addressAll = _this.props.addressData.addresses, addressToRemove = addressAll.find(function (addr) { return addr.id === removeAddressId; }), toastIntent = addressToRemove.primary
                ? VIEWS.ADDRESSES.TOAST_INTENTS.REMOVE_BILLING_PRIMARY
                : VIEWS.ADDRESSES.TOAST_INTENTS.REMOVE_BILLING;
            postData[constants_2.ADDRESS.REMOVE_ADDRESS_ID_KEY] = removeAddressId;
            postData[constants_2.ADDRESS.REMOVE_PRIMARY_KEY] = addressToRemove.primary;
            postData[constants_2.ADDRESS.CARD_IDS_KEY] = addressToRemove.cardList.map(function (card) { return card.id; });
            ajax_util_1.default.post$(_this.props.dispatch, _this.props._csrf, "" + ROUTES.API.ADDRESSES.BILLING.REMOVE, postData, { component: { name: VIEWS.ADDRESSES.BILLING.DELETE } })
                .then(function (addressInfo) {
                if (addressInfo) {
                    var isFlow = _this.props.route.isFlow || false, flowName = _this.props.route.enter.flow || "", isBaseFlowInHistory = _this.props.route.history &&
                        _this.props.route.history.includes(ROUTES.ADDRESSES.FLOW_BASE);
                    _this.props.dispatchRemoveAddressSuccess(addressInfo);
                    _this.props.removeAction(toastIntent);
                    if (addressToRemove.primary &&
                        window &&
                        window.venice &&
                        typeof window.venice.primaryAddressModified ===
                            "function") {
                        window.venice.primaryAddressModified();
                    }
                    if (isFlow && !isBaseFlowInHistory) {
                        var fptiValue = addressToRemove.primary
                            ? _this.props.addressFpti.billing
                                .removeBillingAddressPrimary
                            : _this.props.addressFpti.billing
                                .removeBillingAddress, flowReturnValue = addressToRemove.primary
                            ? constants_2.ADDRESS.FLOW_RETURN_VALUE
                                .REMOVE_BILLING_ADDRESS_PRIMARY
                            : constants_2.ADDRESS.FLOW_RETURN_VALUE
                                .REMOVE_BILLING_ADDRESS_NON_PRIMARY;
                        triggerOperationResult_1.triggerOperationResult(fptiValue, FPTI.SUCCESS, null);
                        route_utils_1.transitionOutHandler();
                        page(constants_1.default.BASE_URI + "/flow-return/" + flowName + "?success=" + flowReturnValue);
                    }
                    else {
                        page.back();
                    }
                }
            })
                .catch(function (error) {
                _this.setState({ showSpinner: false });
                var errorStatusCode = commonweb_utils_1.objectUtils.safeGet(error, "statusCode") || 500;
                var errorDescFPTI;
                if (errorStatusCode >= 400 && errorStatusCode < 500) {
                    var code = addressErrors_1.errorCodes[error.errorKey];
                    var errorContent = _this.props.addressContent.error[code];
                    if (!errorContent) {
                        errorContent = _this.getGenericError();
                    }
                    _this.setState({ errorMessage: errorContent });
                    errorDescFPTI = errorContent;
                }
                else {
                    var genericError = _this.getGenericError();
                    _this.setState({ errorMessage: genericError });
                    errorDescFPTI = genericError;
                }
                triggerOperationResult_1.triggerOperationResult(_this.props.addressFpti.billing.remove, FPTI.FAILURE, errorDescFPTI);
                return;
            });
        };
        _this.state = {
            form: {
                newBillingAddress: null,
            },
            errorMessage: "",
            showSpinner: false,
        };
        return _this;
    }
    RemoveBillingAddress.prototype.componentDidMount = function () {
        window.scroll({ top: 0, behavior: "smooth" });
    };
    RemoveBillingAddress.prototype.setErrorMessageInView = function () {
        window.scroll({ top: 0, behavior: "smooth" });
    };
    RemoveBillingAddress.prototype.render = function () {
        var _this = this;
        var addressAll = this.props.addressData.addresses, removeAddressId = this.props.route.enter.params.id, addressToRemove = addressAll.find(function (addr) { return addr.id === removeAddressId; }), addressFpti = this.props.addressFpti, filteredAddresses = addressAll.filter(function (address) { return address.id !== removeAddressId; }), otherAddresses = filteredAddresses.map(function (address, key) {
            var addressString = (React.createElement(addressDisplay_1.default, { displayMetadata: address.displayMetadata }));
            return {
                label: addressString,
                value: JSON.stringify(address),
            };
        }), cardList = commonweb_utils_1.objectUtils.safeGet(addressToRemove, "cardList") || [], isSingleCardAndItsUpdatable = cardList.length == 1 && cardList[0].isCardAddressUpdatable;
        if (!removeAddressId || !addressToRemove || !cardList.length) {
            return null;
        }
        return (React.createElement("div", null, addressToRemove.cardList.length > 1 ||
            !isSingleCardAndItsUpdatable ? (React.createElement(update_billing_message_view_1.default, null)) : (React.createElement("div", null,
            React.createElement("form", { id: "remove_address_form", onSubmit: this.submitHandler },
                this.state.errorMessage ? (React.createElement(pp_react_1.Alert, { className: "dividerMargin", type: "error" }, this.state.errorMessage)) : null,
                React.createElement("div", null,
                    React.createElement(pp_react_1.Text, { className: "genericAccountHeader", size: "xl3" }, this.props.addressContent.removeBilling
                        .header),
                    React.createElement("div", { key: "billing-cardlist", className: "billing-cardlist" },
                        React.createElement(pp_react_1.Text, { size: "sm" }, interpolate_1.default("inHTMLData", this.props.addressContent.cards.one, {
                            numberOfCards: addressToRemove.cardList
                                .length,
                        })),
                        commonUtils_1.cardsDetails(addressToRemove.cardList)),
                    React.createElement(pp_react_1.Divider, { secondary: true }),
                    React.createElement(pp_react_radio_1.RadioButton, { className: this.state.showSpinner
                            ? "clickDisabled"
                            : null, name: "addressListRadio", value: "", onClick: function (event) {
                            return _this.onClickRadio(event);
                        }, options: otherAddresses }),
                    React.createElement(pp_react_1.Divider, { secondary: true }),
                    React.createElement("div", { className: "removeBilling-addnew" },
                        React.createElement(AddNewLinkComponent, { id: "remove_billing_add_new", content: this.props.addressContent, onAddClick: this.onAddClick, fpti: this.props.addressFpti })),
                    React.createElement(pp_react_1.Divider, { secondary: true })),
                React.createElement("div", { className: "removeBilling-info" },
                    React.createElement(pp_react_1.Text, { size: "sm" }, this.props.addressContent.billing
                        .updateIssuer)),
                React.createElement("div", null,
                    React.createElement(pp_react_1.Button, { className: "fullWidth test_removeButton", name: addressFpti.billing.submitRemove, type: "submit", disabled: this.state.showSpinner }, this.state.showSpinner ? (React.createElement(pp_react_1.LoadingSpinner, { className: "loading-spinner", screenReaderText: this.props.commonContent.loading, inverse: true })) : (this.props.addressContent.removeBilling
                        .save))))))));
    };
    return RemoveBillingAddress;
}(React.Component));
function AddNewLinkComponent(_a) {
    var id = _a.id, onAddClick = _a.onAddClick, content = _a.content, fpti = _a.fpti;
    return (React.createElement(pp_react_1.Link, { id: id, href: "/", onClick: function (e) { return onAddClick(e); }, "data-name": fpti.billing.addNewLink },
        React.createElement(pp_react_1.Icon, { name: "add", size: "sm" }),
        content.manageAdd.link));
}
var mapStateToProps = function (_a) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, route = _a.route, account = _a.account, links = _a.links, fpti = _a.fpti;
    var addressData = account.addressData, addressFpti = fpti.address, addressContent = content.addresses, commonContent = content.common;
    return {
        _csrf: _csrf,
        ui: ui,
        addressContent: addressContent,
        commonContent: commonContent,
        route: route,
        addressData: addressData,
        links: links,
        addressFpti: addressFpti,
    };
};
function mapDispatchToProps(dispatch) {
    return {
        dispatchRemoveAddAddress: function () { return dispatch(addresses_1.removeBillingByAddAddress()); },
        dispatchRemoveAddressSuccess: function (addressInfo) {
            return dispatch(addresses_1.buildAddress(addressInfo));
        },
        removeAction: function (typeOfAction) { return dispatch(addresses_1.actionType(typeOfAction)); },
        dispatch: dispatch,
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(RemoveBillingAddress);
